import {useRef,useMemo} from 'react';
import {useLocation} from 'react-router-dom';
import COMPONENT_MAP from '../Repository/Components.js';

// "Analysis Requests" tab on Account's own detail page (core AccountDetail.js)
// - every AnalysisRequest of this account. "New" opens the AnalysisRequest New
// page with this account pre-filled as parent context (AnalysisRequest.
// account_id - the request then belongs to this account's consumer login).
// list_name omits the account column analysis_requests otherwise shows -
// redundant here since the account is already this page's context.
const AccountAnalysisRequests=({parentId,application,userData,parent})=>{
    const executeQuery=useRef(true);
    const location=useLocation();
    const navigateOnNew={route:'/analysis_request/new/',args:{state:{from:location.pathname,context:{
        parent_name:'Account',
        parent_field_name:'account_id',
        parent_field_value:parentId
    }}}};

    const renderListTab=useMemo(()=>{
        const Component=COMPONENT_MAP['ListTab'];
        return Component?(
            <Component
                parentId={parentId}
                parent={parent}
                application={application}
                userData={userData}
                entityType={'AnalysisRequest'}
                entityParams={['account_id='+parentId]}
                list_name={'account_analysis_requests'}
                height={'50vh'}
                file={'AccountAnalysisRequests.js'}
                navigateOnNew={navigateOnNew}
                initialState={{}}
                checkboxSelection={false}
                disableRowSelectionOnClick={false}
                disableSelectionOnClick={false}
                popupComponent={null}
                executeQuery={executeQuery}
            />
        ):null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[parentId,application.globalData.dataGridParams['account_analysis_requests']]);

    return renderListTab;
};
export default AccountAnalysisRequests;
